import React from 'react';
import { MoonIcon, QuestionIcon, StarIcon, SunIcon } from '@chakra-ui/icons';

type AvatarProps = {
  avatar: number
}

export const avatarOptions = [
  "None",
  "StarIcon",
  "QuestionIcon",
  "SunIcon",
  "MoonIcon"
]

export default function Avatar({avatar} : AvatarProps): JSX.Element {
  let avatarIndex = 0;
  if (avatar >= 0 && avatar < avatarOptions.length) {
    avatarIndex = avatar;
  }
  const avatarVal = avatarOptions[avatarIndex];
  switch (avatarVal) {
    case "StarIcon":
      return <StarIcon />;
    case "QuestionIcon":
      return <QuestionIcon />;
    case "SunIcon":
      return <SunIcon />;
    case "MoonIcon":
      return <MoonIcon />;
    default:
      return <></>;
  }
}